@if (getEndedContract(); as lifecycle) {
  <div class="alert alert-warning d-flex align-items-start gap-2 mb-3" role="alert">
    <acc-icon name="warn"/>
    <div>
      <div class="fw-bold">{{ 'org.lifecycle.exportWindow.title'|translate }}</div>
      <div>{{ 'org.lifecycle.exportWindow.text'|translate:{
        contractEnded: (lifecycle.contractEnded | accDate),
        deletionDue: (lifecycle.deletionDue | accDate),
        daysLeft: lifecycle.daysLeft
      } }}</div>
      @if (perms.export.read) {
        <a class="alert-link" [routerLink]="exportsPath">{{ 'org.lifecycle.exportWindow.export'|translate }}</a>
      }
    </div>
  </div>
}
